module.exports = "<div [class.loader-hidden]=\"!show\">\r\n    <div class=\"loader-overlay\">\r\n        <div>\r\n            <mat-progress-bar mode=\"indeterminate\" *ngIf=\"show\"></mat-progress-bar>\r\n        </div>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./Scripts/fw/loader/loader.component.html
// module id = 2294
// module chunks = 1